import React from 'react';

import './slide-element.scss';



const SlideElement = ({href, content, description, short}) => {
  const width = window.innerWidth;
  return (
      <a href={href} className="slide__element">
        <div className="slide__content-container">
          <img alt="" src={content} className="slide__image"/>
        </div>
        <p className="slide__description">
          {width > 1000 ? description : short ? short : description.split(' ')[0].replace(',','')}
        </p>
      </a>
  );
}

export default SlideElement;
